export function getToastContent(toastMsg) {
    if (toastContent.hasOwnProperty(toastMsg))
        return toastContent[toastMsg]
    else return toastMsg
}

const toastContent = {
    "Invalid OTP.": 'You entered Invalid OTP',
}